export const IHideLoadingUseCaseType = Symbol('IHideLoadingUseCase');
